<style scoped>
.df-section-desc {
    padding-left: 5px;
    white-space: pre-line;
}
</style>
<template>
    <div class="DFSectionHeading" :class="[colClass]">
        <h2 class="df-section-title">{{ effectiveLabel }}</h2>
        <div v-if="settings.description">
            <p class="df-section-desc">{{ settings.description }}</p>
        </div>
        <div class="DFSectionContents clearfix">
            <ChildrenList :children-ids="children" :view-only="isViewOnly"></ChildrenList>
        </div>
        <ErrorList :data="data" />
        <AdminSettingsDifferences :data="data" />
    </div>
</template>
<script lang="ts">
import { useObservable } from "@vueuse/rxjs";
import { defineComponent } from "vue";
import { props, Props, components, setup } from "./BaseDefMixin.3";
import type SectionDef from "../elements/SectionDef";
import type { SectionSettings } from "@cs-ts/section-settings";
export default defineComponent({
    components: {
        ...components,
        //DatePicker,
    },
    props: props,
    //@ts-ignore
    setup(props: Props<SectionDef, SectionSettings>) {
        const base = setup<SectionDef, SectionSettings>(props);

        const effectiveLabel = useObservable(props.data.effectiveLabel$());

        return {
            effectiveLabel,

            ...base.expose,
        };
    },
});
</script>
